import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'LangPt',
  setup(__props) {

const attrs = iconAttributes({ width: 20, height: 20 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"20\" height=\"20\" fill=\"#009B3A\"></rect><path d=\"M10,5 16,10 10,15 4,10 Z\" fill=\"#FEDF00\"></path><circle cx=\"10\" cy=\"10\" r=\"4\" fill=\"#002776\"></circle><path d=\"M7,8.5 Q10,7 13,8.5\" fill=\"none\" stroke=\"white\" stroke-width=\"0.7\" stroke-linecap=\"round\"></path><path d=\"M7,10 Q10,12 13,10\" fill=\"none\" stroke=\"white\" stroke-width=\"0.7\" stroke-linecap=\"round\"></path>", 5)
  ]), 16))
}
}

})